import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../state/reducers/global";
import ModalInsert from "../../components/ModalInsert";
import { useNavigate } from "react-router";
import GenericConfirmInsert from "../../components/GenericConfirmInsert";
import { informationRequest } from "../../../state/reducers/claimDetailsVendor";
import { clearVehicleRegRequest } from "../../../state/reducers/regSearch";
import { setBucketType } from "./../../../state/reducers/toolbar";
import { setActiveConfirmModalOptionsClaims } from "../../../state/reducers/claimDetailsVendor";

const VendorInformationRequestDecision = ({ claimData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onRequestInformation = () => {
    dispatch(informationRequest(claimData, navigate));

    const type = "claims";
    const data = {
      action: "request-information",
    };
  
    dispatch(setActiveConfirmModalOptionsClaims(type, data));
    dispatch(setBucketType("all"));
    dispatch(clearVehicleRegRequest());
  };

  const onCancel = () => {
    dispatch(closeModal());
  };

  return (
    <Fragment>
      <ModalInsert>
          <GenericConfirmInsert
            headerText="Are you sure?"
            bodyText="Are you sure you wish to request information against this claim?"
            onCancel={onCancel}
            onConfirm={onRequestInformation}
          />
      </ModalInsert>
    </Fragment>
  );
};

export default VendorInformationRequestDecision;
